export default __webpack_public_path__ + "static/media/footer-m.8359869d.png";